"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goNovelTab = exports.TabType = exports.bottomTabUrl = exports.topTabUrl = void 0;
const novel_open_base_1 = require("@tencent/novel-open-base");
exports.topTabUrl = 'qb://home/feeds?tabId=22';
exports.bottomTabUrl = 'qb://tab/feedschannel?component=FeedsNovelPage&module=novelsingletab&title=小说&tabId=112&backupUrl=qb%3a%2f%2fhome%2ffeeds%3ftabId%3d22%26ch%3d004530%26refresh%3d1';
const { openUrl, isLargerThan1075 } = novel_open_base_1.qb;
var TabType;
(function (TabType) {
    /** 默认跳转 */
    TabType[TabType["DEFAULT"] = 0] = "DEFAULT";
    /** 顶tab跳转 */
    TabType[TabType["TOP"] = 1] = "TOP";
    /** 底tab跳转 */
    TabType[TabType["BOTTOM"] = 2] = "BOTTOM";
})(TabType = exports.TabType || (exports.TabType = {}));
/**
 * 跳转到对应的小说频道tab, 包括底部tab和顶部tab
 * @param {number} tabType 跳转类型，0默认、1顶tab跳转、2底tab跳转
 * @param {object} [params] 附加参数
 * @param {boolean} [isNeedTBS]
 */
exports.goNovelTab = (tabType, params, isNeedTBS = true) => {
    // 支持跳转通过参数决定跳转到顶部还是底部tab, 支持指定跳转附加参数
    switch (tabType) {
        case TabType.DEFAULT:
            if (isLargerThan1075()) {
                openUrl(exports.bottomTabUrl, params, !!isNeedTBS);
            }
            else {
                openUrl(exports.topTabUrl, params, !!isNeedTBS);
            }
            break;
        case TabType.TOP:
            openUrl(exports.topTabUrl, params, !!isNeedTBS);
            break;
        case TabType.BOTTOM:
            openUrl(exports.bottomTabUrl, params, !!isNeedTBS);
            break;
        default:
            if (isLargerThan1075()) {
                openUrl(exports.bottomTabUrl, params, !!isNeedTBS);
            }
            else {
                openUrl(exports.topTabUrl, params, !!isNeedTBS);
            }
    }
};
